import { HERO_IMAGE_TRANSFORM } from 'src/constants/layout';
import styles from './styles.module.scss';
import { withImageKitTransform } from 'src/utils/imageTransform';
import { useState } from 'react';

type HeroProps = {
  image: string | null;
};

export const Hero = ({ image }: HeroProps) => {
  const [hasError, setHasError] = useState(false);

  if (!image || hasError) return null;

  const src = withImageKitTransform(image, HERO_IMAGE_TRANSFORM);
  
  if (!src) return null;

  return (
    <section className={styles.heroSection}>
      <img
        className={styles.heroImg}
        src={src}
        alt="Cafe hero"
        onError={() => setHasError(true)}
      />
    </section>
  );
};
